import deephowApiServerWrapper from "@/server/api-server";

export const createSummary = (payload) => deephowApiServerWrapper("post", "/v1/ai-summary", payload);

export const deleteSummary = (id) => deephowApiServerWrapper("delete", `/v1/ai-summary/${id}`);

export const updateSummary = (id, payload) => deephowApiServerWrapper("patch", `/v1/ai-summary/${id}`, payload);
